<template>
    <div class="modal__container">
        <div class="modal__content">
            <div title="title" class="modal__header">
                <!-- <icon class="icon--push-right" :class="active ? 'modal-container--active' : ''" @click.prevent="active = !active" icon="times" /> -->
                {{title}}
            </div>
            <div class="modal__body">
              <slot name="body"></slot>
              </div>
            <div class="modal__footer">
              <slot name="footer"></slot>
              </div>
        </div>
    </div>
</template>

<script>

export default {        
  props: [
    'title',
  ],
  data() {
    return {
      active: false,
      data: {
        showModal: false
      }
    }
  }
}
</script>

<style scoped lang="scss">
    @import '../../../scss/elements/modal.scss';
</style>